var map = {
	"./chat/main/Message/index.js": [
		"./pages/chat/main/Message/index.js",
		1
	],
	"./chat/main/PreUsers/index.js": [
		"./pages/chat/main/PreUsers/index.js",
		22
	],
	"./chat/main/Users/index.js": [
		"./pages/chat/main/Users/index.js",
		21
	],
	"./chat/main/index.js": [
		"./pages/chat/main/index.js",
		0
	],
	"./dashboard/articleManage/article.js": [
		"./pages/dashboard/articleManage/article.js",
		2
	],
	"./dashboard/bannerManage/banner.js": [
		"./pages/dashboard/bannerManage/banner.js",
		19
	],
	"./dashboard/baseInfo/config.js": [
		"./pages/dashboard/baseInfo/config.js",
		18
	],
	"./dashboard/brandManage/brand.js": [
		"./pages/dashboard/brandManage/brand.js",
		17
	],
	"./dashboard/categoryManage/category.js": [
		"./pages/dashboard/categoryManage/category.js",
		16
	],
	"./dashboard/goodsManage/goods.js": [
		"./pages/dashboard/goodsManage/goods.js",
		3
	],
	"./dashboard/moduleManage/module.js": [
		"./pages/dashboard/moduleManage/module.js",
		15
	],
	"./dashboard/outerteam/outerTeamCoinGivenHistoryList.js": [
		"./pages/dashboard/outerteam/outerTeamCoinGivenHistoryList.js",
		14
	],
	"./dashboard/outerteam/outerTeamList.js": [
		"./pages/dashboard/outerteam/outerTeamList.js",
		13
	],
	"./dashboard/outerteam/outerTeamMemberList.js": [
		"./pages/dashboard/outerteam/outerTeamMemberList.js",
		12
	],
	"./dashboard/reservation/index.js": [
		"./pages/dashboard/reservation/index.js",
		11
	],
	"./dashboard/tradeManage/comment.js": [
		"./pages/dashboard/tradeManage/comment.js",
		10
	],
	"./dashboard/tradeManage/config.js": [
		"./pages/dashboard/tradeManage/config.js",
		25
	],
	"./dashboard/tradeManage/mpUser.js": [
		"./pages/dashboard/tradeManage/mpUser.js",
		9
	],
	"./dashboard/tradeManage/order.js": [
		"./pages/dashboard/tradeManage/order.js",
		8
	],
	"./dashboard/tradeManage/refund.js": [
		"./pages/dashboard/tradeManage/refund.js",
		7
	],
	"./dashboard/translate/item.js": [
		"./pages/dashboard/translate/item.js",
		6
	],
	"./dashboard/translate/list.js": [
		"./pages/dashboard/translate/list.js",
		5
	],
	"./dashboard/translateManage/translate.js": [
		"./pages/dashboard/translateManage/translate.js",
		4
	],
	"./oauth/login/index.js": [
		"./pages/oauth/login/index.js",
		20
	],
	"./oauth/login/login.js": [
		"./pages/oauth/login/login.js",
		24
	],
	"./oauth/login/register.js": [
		"./pages/oauth/login/register.js",
		23
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./pages lazy recursive ^\\.\\/.*\\.js$";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./pages lazy ^\.\/.*\.js$
// module id = ./pages lazy recursive ^\.\/.*\.js$
// module chunks = 26